import { render, staticRenderFns } from "./serviceRoute.vue?vue&type=template&id=56a496cc&scoped=true&"
import script from "./serviceRoute.vue?vue&type=script&lang=js&"
export * from "./serviceRoute.vue?vue&type=script&lang=js&"
import style0 from "./serviceRoute.vue?vue&type=style&index=0&id=56a496cc&scoped=true&lang=css&"
import style1 from "./serviceRoute.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a496cc",
  null
  
)

export default component.exports